import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "editor" });

  const load = () => api.get("/auth/users").then(({ data }) => setUsers(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/register", form);
      toast.success("Utilisateur créé");
      setForm({ name: "", email: "", password: "", role: "editor" });
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  const inputCls = "w-full border border-tertiary bg-white px-3 py-2 text-sm outline-none focus:border-champagne focus:ring-1 focus:ring-champagne";

  return (
    <div className="max-w-3xl">
      <h1 className="mb-1 font-serif text-3xl text-anthracite">Utilisateurs</h1>
      <p className="mb-8 text-sm text-anthracite/50">Gérez les accès admin & éditeur.</p>

      <form onSubmit={add} data-testid="user-form" className="mb-8 grid gap-3 border border-tertiary bg-white p-5 sm:grid-cols-5">
        <input placeholder="Nom" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} required data-testid="user-name" className={inputCls} />
        <input placeholder="Email" type="email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} required data-testid="user-email" className={inputCls} />
        <input placeholder="Mot de passe" type="password" value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} required data-testid="user-password" className={inputCls} />
        <select value={form.role} onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))} className={inputCls}>
          <option value="editor">Éditeur</option>
          <option value="admin">Admin</option>
        </select>
        <button type="submit" data-testid="user-add" className="inline-flex items-center justify-center gap-2 bg-anthracite px-4 py-2 text-sm font-medium text-ivory hover:bg-black"><Plus className="h-4 w-4" /> Créer</button>
      </form>

      <div className="border border-tertiary bg-white">
        {users.map((u) => (
          <div key={u.id} className="flex items-center justify-between border-b border-tertiary px-5 py-3 last:border-0">
            <div><p className="text-sm font-medium text-anthracite">{u.name}</p><p className="text-xs text-anthracite/50">{u.email}</p></div>
            <span className="rounded-full bg-champagne/10 px-2.5 py-0.5 text-xs font-medium text-champagne">{u.role}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
